const TrendDown = () => (
  <>
    <path
      fill="currentColor"
      d="m19.33 16.096-5.584-5.515a.64.64 0 0 0-.442-.173.57.57 0 0 0-.423.173l-2.421 2.421q-.48.48-1.156.479-.677 0-1.137-.479L3.354 8.158a.5.5 0 0 1-.153-.342.47.47 0 0 1 .153-.366.5.5 0 0 1 .354-.16.5.5 0 0 1 .354.16l4.8 4.8a.6.6 0 0 0 .442.173.6.6 0 0 0 .442-.173l2.421-2.421q.46-.46 1.137-.46t1.136.46l5.56 5.56v-2.793q0-.213.143-.357a.48.48 0 0 1 .357-.143q.213 0 .357.143a.48.48 0 0 1 .143.357v3.692a.784.784 0 0 1-.808.808H16.5a.48.48 0 0 1-.357-.143.49.49 0 0 1-.143-.357q0-.213.143-.357a.48.48 0 0 1 .357-.143z"
    />
  </>
)
export default TrendDown
